import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    align-items: baseline;
    margin-left: 28px;

    ${props => {
        const { isLocal, needMargin } = props

        const justifyContent = isLocal ? 'flex-end' : ''
        const marginBottom = needMargin ? '10px' : '2px'
        const textAlign = isLocal ? 'right' : 'left'

        return css`
            justify-content: ${justifyContent};
            margin-bottom: ${marginBottom};
            & > span {
                text-align: ${textAlign};
            }
        `
    }}

    .message {
        word-break: break-word;
    }

    .timestamp {
        font-size: 8px;
        margin-left: 8px;
        opacity: 0.5;
    }
`
